module.exports = __webpack_public_path__ + "static/media/leo.a456fb65.jpg";